/* eslint-disable */


import router from '@/router'
import api from '@/apis/api'


const state = {
    token: '',
    openid: '',
		mobile: '',
		login_popup_show:false
}

const mutations = {
	SET_login_popup_show:(state, login_popup_show)=>{
		state.login_popup_show = login_popup_show
    },
    SET_TOKEN: (state, token)=>{
        if(token){
            localStorage.setItem("token", token)
        }
    },
		SET_MOBILE:(state, mobile)=>{
			 if(mobile){
				state.mobile = mobile
				localStorage.setItem("mobile", mobile)
			}         
		},
    SET_OPENID:(state, openid)=>{
        if(openid){
            /**一个手机号可能对用多个微信登录，所以不保存到local，只保存到state */
            state.openid = openid
            sessionStorage.setItem("openid", openid)
        }         
    }

}

const actions = {
    SET_OPENID({commit}, code){
        return new Promise((resolve, reject)=>{
            api.get('/p/user/getOpenid', {code:code}).then((r)=>{
                console.log(r, "getOpenid >>>res......")
                    if (r.success) {
                        commit('SET_OPENID', r.data.openid)
                        resolve(r);
                    } else{
                        reject(r.message)
                    }
            })
            // var burl = "https://elven.top"+"/api"+"/wapPayController/wxPayGetOpenidAndAccessToken" ;   // VUE代理的关系要加上api
            // burl = burl+"?oid=3688";

            // var wx_url = "https://open.weixin.qq.com/connect/oauth2/authorize"
            //         + "?appid=wxc73393bede2ae78a"
            //         + "&redirect_uri="+burl
            //         + "&response_type=code"
            //         + "&scope=snsapi_base"
            //         + "&agentid=AGENTID"
            //         + "&state=STATE#wechat_redirect";
            // api.get(wx_url).then(r => {
            //     console.log(r, "r>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>")
            // })

        })        
    }
}

var getters={
    //获取 token  先从store中查找，没有则进入localStorage查找，再次没有则强制进入登录页面, getters是缓存机制，这边返回方法每次都执行
    getToken: (state) => () => {
        let token = localStorage.getItem('token')
				console.log("store gettoken......")
				console.log(token)
        if(token){
            return token
        }else{
            // router.replace({path: '/login'})
            // return false;
            return "";
        }
    },
    getMobile: (state) => () => {
        let mobile = localStorage.getItem('mobile')
        if(mobile){
            return mobile
        }else{
            // router.replace({path: '/login'})
            // return false;
            return "";
        }
    },

    /**一个手机号可能用多个微信登录 所以不保存到本地， 只保存到state */
    getOpenid: (state) => {
        if(state.openid){
            return state.openid
        }else if(sessionStorage.getItem("openid")){
            // let openid = localStorage.getItem('openid')
            // console.log("vuex中存储的openid", openid)
            // if(openid){
            //     state.openid = openid
            //     return openid
            // }else{
            //     //需要重新发起请求获取  TODO
            // }
						return sessionStorage.getItem("openid")
        }else{
					return undefined
				}
    }
}


const userModule = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters

}


export default userModule
